<template>
  <div
    class="features"
    :class="{
      desktop: isDesktop,
      mobile: isMobile,
    }"
  >
    <div class="header-content">
      <h1 class="title">
        導入店務管理系統<br />
        店務管理數位化、系統化
      </h1>
      <h2 class="sub-title">薪資分潤、管店 APP、數據，數位化營運</h2>
      <button @click="toForm($route.name)">聯絡我們</button>
    </div>
  </div>
</template>

<script setup>
import { useWindowSize } from '@vueuse/core'
import { computed } from '@vue/reactivity'
import { toForm } from '@/utils/helper'
const { width } = useWindowSize()

const isDesktop = computed(() => {
  return width.value > 768
})
const isMobile = computed(() => {
  return width.value < 768
})
</script>

<style scoped lang="postcss">
.desktop {
  background-image:url('@/assets/header/2025/features7.webp'),
  url('@/assets/header/2025/features2-bg.webp');
}

.mobile {
  background-image:url('@/assets/header/2025/features7_mobile.webp'),
  url('@/assets/header/2025/features3-bg_mobile.webp');
}

.header-content {
  @apply text-left text-primary-100 px-[136px] pt-[120px];
  @apply <ipad:(px-[20px] pt-[32px]);
}

button {
  @apply bg-secondary-100 text-white rounded-full;
  @apply px-[68px] py-[15px];
  @apply <ipad:(px-[20px] py-[6px] text-[16px] mt-[150px]);
  @apply <tablet:(mt-[200px]);
}

.title {
  @apply m-0 font-bold text-[60px] leading-[86.88px] tracking-[2px] mb-[25px];
  @apply <ipad:(text-[30px] leading-[38px]);
  @apply <tablet:(text-[26px] mb-[20px] leading-[38px]);
}

.sub-title {
  @apply font-medium text-[27.16px] leading-[40px] tracking-[1.51px] mb-[42px];
  @apply <ipad:(text-[16px] leading-[1.3]);
  @apply <tablet:(text-[12px] mb-[20px] leading-[1.3]);
}
</style>
